export default "__VITE_ASSET__701yfx6Q__"